import { Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { extractValueFromParams, isNullOrEmpty, getParentRoutePath } from '@awp/core/utils';
import { MenuService } from '@awp/app-common';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../../../app-common/src/lib/menu.service";
var CheckMenuExistsGuard = /** @class */ (function () {
    function CheckMenuExistsGuard(router, menuService) {
        this.router = router;
        this.menuService = menuService;
    }
    CheckMenuExistsGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        var menuId = route.paramMap.get('menuId');
        var themeId = extractValueFromParams(route, 'themeId');
        return this.menuService.values.pipe(map(function (items) {
            var item = items.find(function (p) { return p.url === menuId; });
            var parentRoutePath = getParentRoutePath(route);
            if (item != null && item.contentUrl != null
                && (parentRoutePath == null || parentRoutePath === themeId || isNullOrEmpty(item.parentUrl))) {
                return true;
            }
            return _this.router.createUrlTree(['/', themeId, 'page', 'not-found']);
        }), take(1));
    };
    CheckMenuExistsGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CheckMenuExistsGuard_Factory() { return new CheckMenuExistsGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.MENU_TOKEN)); }, token: CheckMenuExistsGuard, providedIn: "root" });
    return CheckMenuExistsGuard;
}());
export { CheckMenuExistsGuard };
